import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {SystemAttributesValue} from '../../../model/systemAttributesValue';
import {SysAttrWrapper} from '../../../model/sysAttrWrapper';
import {Constants} from '../../../constants/ebtq-constants';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {UserDetailsModel} from '../../../constants/userModel';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-update-developer-attributes',
  templateUrl: './update-developer-attributes.component.html',
  styleUrls: ['./update-developer-attributes.component.scss']
})
export class UpdateDeveloperAttributesComponent implements OnInit {
  sysAttr: any[];
  attrName!: string;
  selectedAttr: string;
  selectedAttrLabel: string;
  loader = false;
  flagName: string;
  flagVal!: any[];
  selectedFlag!: string;
  successMess: boolean;
  showErrorDiv: boolean;
  errHeading: string;
  containsError = false;
  errorMsg!: string;
  userDetails!: UserDetailsModel;
  errMessage: string;
  title = 'Update System Attributes';

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {

    this.sysAttr = [];
    this.sysAttr.push({label: Constants.DELIVERY_SYS_AVAILABLE, value: Constants.DELIVERY_SYS_AVAILABLE});
    this.sysAttr.push({label: Constants.EBQ_SYS_AVAILABLE, value: Constants.EBQ_SYS_AVAILABLE});
    this.sysAttr.push({label: Constants.EXTRANAL_SYS_AVAILABLE, value: Constants.EXTRANAL_SYS_AVAILABLE});
    this.sysAttr.push({label: Constants.REVERESE_MRT_SYS_AVAILABLE, value: Constants.REVERESE_MRT_SYS_AVAILABLE});
    this.sysAttr.push({label: Constants.SERVICING_SYSTEM_AVAILABLE, value: Constants.SERVICING_SYSTEM_AVAILABLE});
    this.selectedAttr = this.sysAttr[0].value;
    this.selectedAttrLabel = this.sysAttr[0].label;
    this.flagName = '';
    this.successMess = false;
    this.showErrorDiv = false;
    this.errHeading = Constants.ERR_HEADER;
    this.errMessage = Constants.ATTR_VAL_EMPTY_MESS;
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
  }

  getSystemAttr() {
    this.flagVal = [];
    this.flagVal.push({label: 'true', value: 'true'});
    this.flagVal.push({label: 'false', value: 'false'});
    this.loader = true;
    let resultMap: { [key: string]: any; };
    this.attrName = '';
    this.showErrorDiv = false;
    this.successMess = false;
    this.apiService.getSystemAttr(this.selectedAttr + ' Available')
      .subscribe(
        (data: any) => {
          resultMap = data.sysAttrMap;
          this.attrName = this.selectedAttr;
          this.flagName = this.selectedAttr + ' Available';
          if (this.selectedAttr === Constants.DELIVERY_SYS_AVAILABLE) {
            this.selectedFlag = resultMap.isDeliverySysAvailable;
          } else if (this.selectedAttr === Constants.EBQ_SYS_AVAILABLE) {
            this.selectedFlag = resultMap.systemAvailabilityIndicator;
          } else if (this.selectedAttr === Constants.EXTRANAL_SYS_AVAILABLE) {
            this.selectedFlag = resultMap.isExternalAccessAvailable;
          } else if (this.selectedAttr === Constants.REVERESE_MRT_SYS_AVAILABLE) {
            this.selectedFlag = resultMap.RMAvailabilityIndicator;
          } else if (this.selectedAttr === Constants.SERVICING_SYSTEM_AVAILABLE) {
            this.selectedFlag = resultMap.isServicingSysAvailable;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  updateSystemAttributesLimit() {
    this.showErrorDiv = false;
    this.successMess = false;
    this.userDetails = Constants.USER_DETAILS;
    let attrFlgName: string;

    if (this.selectedAttr === Constants.DELIVERY_SYS_AVAILABLE) {
      attrFlgName = 'isDeliverySysAvailable';
    } else if (this.selectedAttr === Constants.EBQ_SYS_AVAILABLE) {
      attrFlgName = 'systemAvailabilityIndicator';
    } else if (this.selectedAttr === Constants.EXTRANAL_SYS_AVAILABLE) {
      attrFlgName = 'isExternalAccessAvailable';
    } else if (this.selectedAttr === Constants.REVERESE_MRT_SYS_AVAILABLE) {
      attrFlgName = 'RMAvailabilityIndicator';
    } else if (this.selectedAttr === Constants.SERVICING_SYSTEM_AVAILABLE) {
      attrFlgName = 'isServicingSysAvailable';
    }
    this.updateFlag(attrFlgName!);
  }

  updateFlag(attrFlgName: string) {
    let sysAttrWrapper: SysAttrWrapper = new SysAttrWrapper();
    let sysAttVal: SystemAttributesValue = new SystemAttributesValue();
    sysAttrWrapper = new SysAttrWrapper();
    sysAttVal = new SystemAttributesValue();
    sysAttVal.attributeName = attrFlgName;
    sysAttVal.attributeValue = this.selectedFlag;
    sysAttVal.lastUpdateUserID = sessionStorage.getItem('userID') ?? undefined;
    sysAttrWrapper.systemAttributesValue = undefined;
    sysAttrWrapper.systemAttributesValue = sysAttVal;

    this.apiService.updateSysAttr(sysAttrWrapper).subscribe((data: any) => {
      if (data === 1) {
        this.successMess = true;
      } else {
        this.showErrorDiv = true;
      }
      this.cdr.detectChanges();
    },
    error => {
      this.errorService.announceError(error);
    });
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

}

